import React from 'react';

const Seguros = () => {
  const seguros = [
    {
      id: 1,
      titulo: "Seguro de Carga Completa",
      imagen: "https://images.unsplash.com/photo-1600880292203-757bb62b4baf?w=500",
      descripcion: "Protección integral para todos sus bienes durante el transporte. Cubre daños por accidentes, robo y eventos naturales. Incluye cobertura hasta $50.000.000 con deducible mínimo."
    },
    {
      id: 2, 
      titulo: "Seguro de Responsabilidad Civil",
      imagen: "https://images.unsplash.com/photo-1454165804606-c3d57bc86b40?w=500",
      descripcion: "Cobertura ante daños a terceros durante el proceso de mudanza. Incluye protección legal y asesoría especializada. Respaldo financiero ante incidentes con otros vehículos o propiedades."
    },
    {
      id: 3,
      titulo: "Seguro de Objetos Valiosos",
      imagen: "https://images.unsplash.com/photo-1584438784894-089d6a62b8fa?w=500",
      descripcion: "Protección especial para artículos de alto valor como obras de arte, electrónicos y antigüedades. Evaluación personalizada y cobertura específica según el valor declarado."
    }
  ];

  return (
    <div className="bg-gray-100 min-h-screen py-12 px-4">
      <div className="max-w-6xl mx-auto">
        {/* Título principal */}
        <div className="text-center mb-12">
          <h2 className="text-4xl font-bold text-[#8B0000] mb-4">Nuestros Seguros</h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Protege tus pertenencias con nuestras opciones de seguro diseñadas para brindarte tranquilidad y seguridad en cada mudanza.
          </p>
        </div>
        
        {/* Tarjetas de seguros */}
        <div className="space-y-8">
          {seguros.map((seguro) => (
            <div
              key={seguro.id}
              className="bg-white rounded-xl shadow-lg overflow-hidden flex flex-col md:flex-row hover:shadow-xl transition-shadow duration-300"
            >
              <div className="md:w-1/3">
                <img 
                  src={seguro.imagen} 
                  alt={seguro.titulo}
                  className="w-full h-64 object-cover"
                />
              </div>
              <div className="md:w-2/3 p-6">
                <h3 className="text-xl md:text-2xl font-bold text-[#8B0000] mb-4">
                  {seguro.titulo}
                </h3>
                <p className="text-gray-600 leading-relaxed">{seguro.descripcion}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Seguros;
